<ng-container *ngIf="templates$ | async as templates">
  <ng-container *ngIf="!isLoading">
    <div class="content">
      <span class="description subtitle">
        {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_PROPOSAL.DESCRIPTION' | translate }}
      </span>
      <glxy-form-field required="true">
        <glxy-label>
          {{ 'COMMON.TITLE' | translate }}
        </glxy-label>
        <input matInput type="text" [formControl]="titleControl" />
        <glxy-error *ngIf="titleControl.hasError('required') && titleControl.dirty">
          {{ 'COMMON.REQUIRED' | translate }}
        </glxy-error>
      </glxy-form-field>
      <glxy-form-field required="true">
        <glxy-label>
          {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_PROPOSAL.TEMPLATE' | translate }}
        </glxy-label>
        <mat-select [formControl]="templateIdControl" required="true">
          <mat-option *ngFor="let template of templates" [value]="template.documentId">
            {{ template.title }}
          </mat-option>
        </mat-select>
        <glxy-error *ngIf="templateIdControl.hasError('required') && templateIdControl.dirty">
          {{ 'COMMON.REQUIRED' | translate }}
        </glxy-error>
      </glxy-form-field>
    </div>
  </ng-container>
</ng-container>

<ng-container *ngIf="isLoading">
  <div class="content side-drawer-shimmer-container">
    <span class="title stencil-shimmer"></span>
    <span class="selector stencil-shimmer"></span>
  </div>
</ng-container>
